import React, { Component } from 'react';

//IMPORT REDUX
import { connect } from 'react-redux';
import {
    addModalAddToList,
    addArticle,
    addToList,
    addList,
    addAtlError
} from '../../../redux/actions/ConfigFileAction'

//IMPORT SEMANTIC COMPONENTS
import 'semantic-ui-css/semantic.min.css';
import {
    Grid,
    Segment,
    Item,
    Form,
    Button,
    Container,
    Divider,
    Icon,
    Modal,
    Header,
    Image,
    Input,
} from 'semantic-ui-react';
import Listes from '../../../assets/svg/Listes.svg';
import Exit from '../../../assets/svg/Exit.svg';

import { translate } from "react-translate";
import ModalTooMuchLists from '../Listes/ModalTooMuchLists';

import API from '../../../services/api';

const mapStateToProps = state => ({
    app: state.app,
    configfile: state.configfile
})


const mapActionToProps = {
    addModalAddToList: addModalAddToList,
    addArticle: addArticle,
    addToList: addToList,
    addList: addList,
    addAtlError: addAtlError
}


class ConnectedModalAddToList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: '',
            open: false,
        }

        this.closeModalAddToList = this.closeModalAddToList.bind(this)
        this.addArticle = this.addArticle.bind(this)
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this)
        this.closeModalTooMuchListsOpen = this.closeModalTooMuchListsOpen.bind(this);
				this.handleNewList = this.handleNewList.bind(this)
    }

    closeModalTooMuchListsOpen() {
        this.setState({
            isModalTooMuchListsOpen: false,
        })
    }

    closeModalAddToList() {
        this.props.addModalAddToList(false)
    }
    openModalAddToList() {
        this.props.addModalAddToList(true)
    }

    addArticle(article) {
        this.props.addArticle(article)
    }

    addAtlError(atlError) {
        this.props.addAtlError(atlError)
    }

    openNewListModal = () => {
        this.setState({
            open: true
        })
    }

    closeNewListModal = (event) => {
				if (event) {
					event.preventDefault()
				}
        this.setState({
            open: false
        })
    }

    handleChangeName(e) {
        this.setState({
            value: e.target.value
        })
    }

    addToList(atl) {
        this.props.addToList(atl)
    }

    addList(list) {
        this.props.addList(list)
    }

    addArticleToList(id) {
        this.props.configfile.article.map(x => {
            if (x.pkuida != undefined) {
                let price = x.price === undefined ? 0 : x.price;
                var articleData = {
                    fkuidlist: id,
                    fkuidarticle: x.pkuida,
                    quantity : x.quantity,
                    price: price,
                    state: "1"
                };
                API.createArticle(this.props.app.token, articleData).then((res) => {
                    this.addArticle(null);
                    this.closeModalAddToList();
                    window.location = "http://" + window.location.host + "#/listdetail/" + id;
                });
            }
            else if (x.pkuidga != undefined) {
                let price = x.price === undefined ? 0 : x.price;
                var groupArticleData = {
                    fkuidlist : id,
                    fkuidgrouparticle: x.pkuidga,
                    quantity : x.quantity,
                    price: price,
                    state: 1,
                    lang: this.props.app.lang
                };
                API.createGroupArticle(this.props.app.token, groupArticleData).then((res) => {
                    this.addArticle(null);
                    this.closeModalAddToList();
                    window.location = "http://" + window.location.host + "#/listdetail/" + id;
                });

            }
            else if (x.manual != undefined) {
                let lang;
                Object.entries(x.manual).map((key, Mainindex) => {
                    if (key[0] === this.props.lang) {
                        lang = key[1]
                    }
                })
                let reg = new RegExp("%%[a-zA-Z]%%", 'g')
                let array1
                let result = []
                while ((array1 = reg.exec(lang)) !== null) {
                    result.push(array1[0].replace(new RegExp("%%", 'g'), ''))
                }
                this.props.configfile.calculResult.map(x => {
                    result.map(y => {
                        if (x.variable === y) {
                            lang = lang.replace(new RegExp("%%[" + y + "]%%", 'g'), x.value)
                        }
                        if (x.variable === this.props.currency) {
                            lang = lang.replace(new RegExp("%%[" + y + "]%%", 'g'), this.props.currency)
                        }
                    })
                })


                var form = new FormData();
                form.append("fkuidlist", id);
                form.append("name_manually", lang);
                form.append("quantity", x.quantity);
                let price = x.price === undefined ? 0 : x.price;
                form.append("price", price);
                form.append("state", 1);
                API.createManualArticle(this.props.app.token, form).then((res) => {
                    this.addArticle(null);
                    this.closeModalAddToList();
                    window.location = "http://" + window.location.host + "#/listdetail/" + id;
                });

            }
        })



    }

    handleSubmit() {
        let name;
        if (this.state.value === null || this.state.value === "") {
            name = "Sans nom";
        } else {
            name = this.state.value;
        }
        var listData = {
            fkuiduser: this.props.app.id,
            name: name
        };

        API.createList(this.props.app.token, listData).then((res) => {
            var response = res.data;
            if (response.msg === 'b_unlimitedlists') {
                this.closeNewListModal()
                this.setState({
                    isModalTooMuchListsOpen: true,
                })
            } else {
                this.addArticleToList(response.pkuidlist)
            }
        });
    }

    handleNewList(event) {
        event.preventDefault();
        this.handleSubmit();
        this.closeNewListModal();
    }

    render() {
        const { t } = this.props;
        <Modal.Header id="modalHeader">
            <Image src={Exit} onClick={this.closeModalAddToList} floated='right' />
            <Header as='h2' textAlign='center' id="modalTitle" >
                {t("title")}
            </Header>
        </Modal.Header>
        return (
            <div>
                <Modal

                    open={this.props.configfile.modal_addToList}
                    onClose={this.closeModalAddToList}
                    size='tiny'>
                    <Modal.Header id="modalHeader">
                    <Grid>
                        <Grid.Row>
                            <Grid.Column textAlign='center'>
                                <Image
                                  id="modalExit"

                                  src={Exit}
                                  floated='right' />
                                <Header
                                  src={Listes}
                                  as='h2'
                                  id="modalTitle"
                                  textAlign='center'>
                                  <Image src={Listes} style={{ maxHeight: '30px', margin: '0'}} />
                                  Listes
                                </Header>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    </Modal.Header>
                    {
                        this.props.configfile.addToList ? (
                            <div>
                                <Modal.Content image>
                                    <Segment>
                                        <Header as='h3' style={{ color: '#727272', marginTop: '20px', marginBottom: '20px', fontSize: '1.7em', fontWeight: '600' }}>Reprendre une list de travaux:</Header>
                                        <Grid
                                            textAlign='center'
                                            style={{ height: '100%' }}
                                            verticalAlign='middle'>
                                            <Grid.Row columns={1}>
                                                <Grid.Column>
                                                    {
                                                        this.props.configfile.list ? (
                                                            Object.entries(this.props.configfile.list).map((key, Mainindex) => {
                                                                if (parseInt(key[0]) === Mainindex) {
                                                                    return (
                                                                        <Segment style={{ borderRadius: '7px', border: '1px solid #c2c2c2' }}>
                                                                            <Grid
                                                                                textAlign='center'
                                                                                style={{ height: '100%' }}
                                                                                verticalAlign='middle'
                                                                            >
                                                                                <Grid.Row columns={3} style={{paddingTop: '10px', paddingBottom: '10px'}}>
                                                                                    <Grid.Column
                                                                                        width={6}
                                                                                        textAlign='left'
                                                                                        style ={{ color: '#707070', fontSize: '1.5em' }}>
                                                                                        {key[1].name}
                                                                                    </Grid.Column>
                                                                                    <Grid.Column width={6}>
                                                                                        <Grid
                                                                                            textAlign='left'
                                                                                            style={{ height: '100%' }}
                                                                                            verticalAlign='middle' >
                                                                                            <Grid.Row>
                                                                                                <Grid.Column textAlign='left' style ={{ color: '#707070', fontSize: '1.5em' }}>
                                                                                                  {key[1].nb_article + " Articles"}
                                                                                                </Grid.Column>
                                                                                            </Grid.Row>
                                                                                        </Grid>
                                                                                    </Grid.Column>
                                                                                    <Grid.Column width={4}>
                                                                                        <Button
                                                                                          size='small'
                                                                                          floated='right'
                                                                                          style = {{ color: '#0964c1', backgroundColor: '#dfe9f6', border: '1px solid #0964c1', fontFamily: 'MavenPro', fontSize: '1.2em'}}
                                                                                          onClick={(e) => this.addArticleToList(key[1].pkuidlist)} >
                                                                                          {t("choix")}
                                                                                        </Button>
                                                                                    </Grid.Column>
                                                                                </Grid.Row>
                                                                            </Grid>
                                                                        </Segment>
                                                                    )
                                                                }
                                                                if (key[0] === "code" && parseInt(key[1]) === 404) {
                                                                    return (
                                                                        <Segment>{t("no_list")}</Segment>
                                                                    )
                                                                }
                                                            })
                                                        ) : (
                                                                <div></div>
                                                            )
                                                    }
                                                </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Row columns={2}>
                                                <Grid.Column>
                                                    <Button
                                                      fluid
                                                      id="cancelBtn"
                                                      size='massive'
                                                      onClick={this.closeModalAddToList} >
                                                      {t("cancel")}
                                                    </Button>
                                                </Grid.Column>
                                                <Grid.Column>
                                                    {
                                                      <Modal
																													dimmer={true}
                                                          open={this.state.open}
                                                          onOpen={this.open}
                                                          onClose={this.closeNewListModal}
                                                          size='tiny'
																													trigger={<Button fluid size='massive' id="validBtn" onClick={this.openNewListModal}
																													 >
																														<Icon name={"plus circle"} />{t("new_list")}
																													</Button>}
                                                      >
                                                          <Modal.Header id="modalHeader">
                                                              <Image src={Exit} onClick={(e) => this.closeNewListModal(e)} floated='right' className='subCloseButton' />
                                                              <Header as='h2' textAlign='center' id="modalTitle" >
                                                                  {t("create_list")}
                                                              </Header>
                                                          </Modal.Header>
                                                          <Modal.Content>
                                                              <Grid>
																																	<Grid.Row style={{paddingBottom:'0', paddingTop:'40px'}}>
																																			<Grid.Column style={{color: 'rgb(114, 114, 114)', fontSize: '1.7em'}}>
																																					{t("name_list")}
																																			</Grid.Column>
																																	</Grid.Row>
                                                                  <Grid.Row>
                                                                      <Grid.Column width={16}>
                                                                          <Form onSubmit={this.handleSubmit}>
                                                                              <Input style={{ backgroundColor: '#f7f7f9' }} placeholder='Liste 01' value={this.state.value} fluid onChange={this.handleChangeName} />
                                                                          </Form>
                                                                      </Grid.Column>
                                                                  </Grid.Row>
                                                                  <Grid.Row columns={2}>
                                                                      <Grid.Column width={8}>
                                                                          <Button
                                                                            size='massive'
                                                                            id="cancelBtn"
                                                                            fluid
                                                                            inverted
                                                                            onClick={(e) => this.closeNewListModal(e)}>
                                                                            {t("close")}
                                                                          </Button>
                                                                      </Grid.Column>
                                                                      <Grid.Column width={8}>
                                                                          <Button
                                                                            size='massive'
                                                                            id="validBtn"
                                                                            inverted
                                                                            fluid
																																						onClick={(e) => this.handleNewList(e)}>
                                                                            {t("create")}
                                                                          </Button>
                                                                      </Grid.Column>
                                                                  </Grid.Row>
                                                              </Grid>
                                                          </Modal.Content>
                                                      </Modal>
                                                    }
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                    </Segment>
                                </Modal.Content>
                            </div>
                        ) : (
                                <div>
                                    <Modal.Content image>
                                        <div>
                                            <Segment>
                                                <Grid
                                                    textAlign='center'
                                                    style={{ height: '100%' }}
                                                    verticalAlign='middle'>
                                                    <Grid.Column>
                                                        <a href='/'><Image floated='right' /></a>
                                                        <Header as='h3' style={{ color: '#0964c1', margin: '1em 0 1em 0' }} textAlign='center'>
                                                            {t("error")}
                                                        </Header>
                                                        <Header as='h5' style={{ margin: '2em 0 2em 0' }}>{this.props.configfile.atlError}</Header>
                                                    </Grid.Column>
                                                </Grid>
                                            </Segment>
                                        </div>
                                    </Modal.Content>
                                </div>
                            )
                    }
                </Modal>
								<ModalTooMuchLists
                  isOpen={this.state.isModalTooMuchListsOpen}
                  close={this.closeModalTooMuchListsOpen}
                />
            </div>
        )
    }
}

const ModalAddToList = connect(mapStateToProps, mapActionToProps)(ConnectedModalAddToList);
export default translate("ModalAddToList")(ModalAddToList);



// WEBPACK FOOTER //
// ./src/components/Protected/Travaux/ModalAddToList.jsx